import React from 'react';
import PropTypes from 'prop-types';

import { CompanyDomainFilter } from '../companyDomain';
import { CompanyNameFilter } from '../companyName';
import { useCompanyFilter } from './useCompanyFilter';

export const CompanyFilter = ({
  companyName,
  companyDomain,
  companyNameIncluded,
  companyNamePeriod,
  setFilters,
  sharedList,
  orderBy,
}) => {
  const { isBulkMode, handleToggleBulkMode } = useCompanyFilter({
    companyDomain,
    setFilters,
  });

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          cursor: 'pointer',
        }}
        onClick={handleToggleBulkMode}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggleBulkMode();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={isBulkMode ? 'Switch to select companies' : 'Switch to bulk add'}
      >
        <span style={{ display: 'block', fontSize: '12px', textDecoration: 'underline' }}>
          {isBulkMode ? 'Select companies' : 'Add in bulk'}
        </span>
      </div>
      {isBulkMode ? (
        <CompanyDomainFilter
          value={companyDomain}
          companyNameIncluded={companyNameIncluded}
          companyNamePeriod={companyNamePeriod}
          setFilters={setFilters}
        />
      ) : (
        <CompanyNameFilter
          value={companyName}
          companyNameIncluded={companyNameIncluded}
          companyNamePeriod={companyNamePeriod}
          setFilters={setFilters}
          sharedList={sharedList}
          orderBy={orderBy}
        />
      )}
    </div>
  );
};

CompanyFilter.propTypes = {
  companyName: PropTypes.array,
  companyDomain: PropTypes.array,
  companyNameIncluded: PropTypes.object,
  companyNamePeriod: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
};

CompanyFilter.defaultProps = {
  companyName: [],
  companyDomain: [],
  companyNameIncluded: null,
  companyNamePeriod: null,
  sharedList: null,
  orderBy: 'count',
};
